import React from "react";

const Alignment = ({ children, image, direction, body }) => {
  return (
    <div className={`align-${direction}`}>
      {body !== "undefined" && (
        <blockquote>
          <p className={"text"}>{body}</p>
        </blockquote>
      )}

      {children &&
        children.map((item) => <div key={`item-${item.key}`}>{item}</div>)}
    </div>
  );
};

export default Alignment;
